import { Link } from 'react-router-dom';
import logo from '../../../../assets/images/informer-logo.png';
import { Button } from '../../../../components/button/button';
import { Container } from '../../../../components/container/container';
import { Input } from '../../../../components/input/input';
import { PasswordInput } from '../../../../components/input/password-input';
import { Message } from '../../../../components/message/message';
import { LangSelect } from '../../../../features/lang-select/lang-select';
import { concatPath } from '../../../../helpers/path';
import { AuthPath, ManagerPath, RootPath } from '../../../../routes/manager/manager-enums';
import s from './restore.module.css';
import { useRestore } from './use-restore';

export const Restore = () => {
  const {
    changePasswordData,
    handleUpdateNewPass,
    handleUpdateRepeatPass,
    handleUpdateKey,
    handleChangePassword,
    error,
    handleRestore,
    handleUpdateRestoreData,
    isLoading,
    isOk,
    restoreData,
    handleChangeLang,
    t,
  } = useRestore();

  return (
    <div className={s.page}>
      <header className={s.header}>
        <img src={logo} alt="logo" className={s.logo} />
        <h2>{t('Восстановление пароля')}</h2>
        <Container label={t('Введите вашу почту для восстановления пароля')} required>
          <LangSelect className={s.lang} data-testid="lang-select" onChange={handleChangeLang} />
        </Container>
      </header>
      <div className={s.inputs}>
        <Container label={t('Почта')} required>
          <Input
            value={restoreData?.email}
            onChange={(e) => handleUpdateRestoreData({ email: e.currentTarget.value })}
            name="email"
            size="lg"
            disabled={isLoading || isOk}
            data-testid="email-input"
          />
        </Container>

        {error && <Message description={t(error)} variant="danger" />}
        {isOk ? (
          <>
            <Container label={t('Ключ восстановления')} required>
              <Input
                value={changePasswordData?.key}
                onChange={handleUpdateKey}
                name="key"
                data-testid="key-input"
              />
            </Container>
            <Container label={t('Новый пароль')}>
              <PasswordInput
                autoComplete="new-password"
                value={changePasswordData?.password}
                onChange={handleUpdateNewPass}
                name="newPassword"
                data-testid="new-password-input"
              />
            </Container>

            <Container label={t('Повторите новый пароль')}>
              <PasswordInput
                autoComplete="new-password"
                value={changePasswordData?.repeatPassword}
                onChange={handleUpdateRepeatPass}
                name="repeatPassword"
                data-testid="repeat-password-input"
              />
            </Container>

            <Button disabled={isLoading} onClick={handleChangePassword} data-testid="change-button">
              {t('Изменить пароль')}
            </Button>
          </>
        ) : (
          <Button disabled={isLoading} onClick={handleRestore} data-testid="restore-button">
            {t('Восстановить пароль')}
          </Button>
        )}
        <Link
          to={concatPath([RootPath.Manager, ManagerPath.Auth, AuthPath.Login])}
          data-testid="login-link"
        >
          <Button variant="secondary" fullWidth>
            {t('Вернуться на страницу авторизации')}
          </Button>
        </Link>
      </div>
      <footer className={s.footer}>Informer Center © 2024 {t('все права защищены')}.</footer>
    </div>
  );
};
